export default __webpack_public_path__ + "static/media/m2_bkVdo.1929cabf.png";